export const SET_VALIDATION_GROUP =
  'app/DataValidationModal/SET_VALIDATION_GROUP';
export const OPEN_DATA_VALIDATION_MODAL =
  'app/DataValidationModal/OPEN_DATA_VALIDATION_MODAL';
export const DATA_VALIDATION_FIELD_ARIA_LABEL = 'Data Validation Dialog';
